module.exports = __webpack_public_path__ + "img/5.df556b6a.png";